export const tradingActionTypes = {

    GET_GRID_OWNERS_LIST_REQUEST: 'GET_GRID_OWNERS_LIST_REQUEST',
    GET_GRID_OWNERS_LIST_SUCCESS: 'GET_GRID_OWNERS_LIST_SUCCESS',
    GET_GRID_OWNERS_LIST_FAILURE: 'GET_GRID_OWNERS_LIST_FAILURE',

    GET_GRID_LIST_REQUEST: 'GET_GRID_LIST_REQUEST',
    GET_GRID_LIST_SUCCESS: 'GET_GRID_LIST_SUCCESS',
    GET_GRID_LIST_FAILURE: 'GET_GRID_LIST_FAILURE'
};